/* eslint-disable react/display-name */
import {
  Button,
  Collapse,
  Grid,
  IconButton,
  Tooltip,
  Alert,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import DeleteSweepOutlinedIcon from "@mui/icons-material/DeleteSweepOutlined";
import PCheck from "../../../../components/pos/PCheck";
import PConfirm from "../../../../components/pos/PConfirm";
import PSelect from "../../../../components/pos/PSelect";
import PText from "../../../../components/pos/PText";
import db from "../../../../db/db";
import MUIDataTable from "mui-datatables";
import React, { useEffect, useState } from "react";
import BarcodeReader from "react-barcode-reader";
import { useTranslation } from "react-i18next";
import AsyncSelect from "react-select/async";
import readXlsxFile from "read-excel-file";
import { StringUtils } from "../../../../utils/StringUtils";
import { SyncUtils } from "../../../../utils/SyncUtils.jsx";
import ProductCrud from "../../../product/ProductCrud.jsx";
import API from "../../../../utils/API";
import Link from "@mui/material/Link";
import AgGridQuickPurchaseList from "./AgGridQuickPurchaseList";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

export default function QuickPurchaseRequestList(props) {
  const { t } = useTranslation();
  const translate = t;
  const [prodLookupValue, setProdLookupValue] = useState();
  const [isConsolidated, setConsolidated] = useState(true);
  const [unitTypeOptions, setUnitTypeOptions] = useState([]);
  const [dataTableHeight, setDataTableHeight] = useState(0);
  const [confirmContext, setConfirmContext] = useState({ open: false });
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [productSetting, setProdoductSetting] = useState({});
  const [showImport, setShowImport] = useState(false);

  const [disableLoading, setDisableLoading] = useState(false);
  const [disableImport, setDisableImport] = useState(true);
  const [importing, setImporting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertFlag, setAlertFlag] = useState(false);

  const [productInfoFields, setProductInfoFields] = useState([]);
  const [storeAdminSetting, setStoreAdminSetting] = useState();
  const [showProductCrud, setShowProductCrud] = useState(false);
  const [origObject, setOrigObject] = useState(null);
  const [pricingLevels, setPricingLevels] = useState([]);

  props.biRef.requestList = {
    parentEvent: parentEvent,
  };

  const valType = [
    "SN",
    "PRODUCT_NAME",
    "UNIT",
    "RECEIVED_QTY",
    "foc",
    "RECEIVED_COST",
    "DISCOUNT",
    "COST_AFTER_DISCOUNT",
    "TAX_PER",
    "TAX_TYPE",
    "TAX_COST",
    "COST_WITHOUT_TAX",
    "FINAL_COST",
  ];

  var biRef = {};

  useEffect(() => {
    loaadByDB();
    loadProductSetting();
    loadPricingLevels();

    /*Dynamic screen height adjustment*/
    function handleResize() {
      setDataTableHeight(getWindowDimensions().height - 600);
    }
    setDataTableHeight(getWindowDimensions().height - 600);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  async function loadPricingLevels() {
    /*let result = await API.get("/api/v1/product/pricing/levels");
    let pricingLevelArray = [];
    let index = 0;*/
    let pricingLevelArray = [];
    let index = 0;

    let dbData = await db.config
      .where("name")
      .equals("PRODUCT_PRICING_LEVELS")
      .toArray();
    if (
      dbData[0] != null &&
      dbData[0] != undefined &&
      dbData[0].configTxt != null &&
      dbData[0].configTxt != undefined &&
      dbData[0].configTxt != ""
    ) {
      console.log("INSIDE");
      let configText = dbData[0].configTxt;
      JSON.parse(configText).map((item) => {
        pricingLevelArray.push({
          id: index,
          name: item.name,
          cost: "0",
          marginPercentage: "0",
          margin: "0",
          priceWithoutTax: "0",
          isSelected: false,
        });
        index++;
      });
      setPricingLevels(pricingLevelArray);
    } else {
      setPricingLevels([]);
    }
  }

  async function loadProductSetting() {
    let val = await db.setting.where("sKey").equals("product").toArray();
    let pSetting = JSON.parse(val[0].sValue);
    setProdoductSetting(pSetting);
  }
  useEffect(() => {
    var enableAutoScroll = sessionStorage.getItem("enableAutoScroll");
    if (enableAutoScroll && enableAutoScroll == "true") {
      scollToActiveElem();
      sessionStorage.removeItem("enableAutoScroll");
    }
  }, [props.data]);

  async function loaadByDB() {
    let dbData = await db.config.where("name").equals("UNIT_TYPES").toArray();
    setUnitTypeOptions(JSON.parse(dbData[0].configTxt));

    let dbData2 = await db.config
      .where("name")
      .equals("PRODUCT_INFO_CUSTOM_FIELDS")
      .toArray();
    if (dbData2 && dbData2.length == 1) {
      setProductInfoFields(JSON.parse(dbData2[0].configTxt));
    }

    let storeAdminVal = await db.setting
      .where("sKey")
      .equals("store_admin")
      .toArray();
    if (storeAdminVal && storeAdminVal[0] && storeAdminVal[0].sValue)
      setStoreAdminSetting(JSON.parse(storeAdminVal[0].sValue));
  }

  function parentEvent(eventType) {
    if (eventType == "isTaxEnabled") return props.isWithTax;
  }

  function updateData(eventSource, meta, value, index) {
    if (eventSource === "table") {
      let dat = [...meta.tableData];
      updatevalues(
        dat[meta.rowIndex],
        valType[meta.columnIndex],
        value,
        meta.columnIndex
      );
      props.updatePurchaseItemData(dat);
    }
    /*if (eventSource === "crud") {
    }*/
  }

  async function onLinkClikedForProductCrud(id) {
    try {
      let { data } = await API.get("/api/v1/product/" + id);
      setOrigObject(data);
      setShowProductCrud(true);
      //setOpenWindow(true);
    } catch (err) {
      console.log(err);
      props.showMessage(
        "error",
        translate("Not able to retrive Product data from server")
      );
    }
  }

  function updatevalues(rowData, valType, value, colIndex) {
    if (colIndex != null) rowData[colIndex] = value;

    let receivedQty = 0;
    let foc = {};
    let taxType = {};
    let receivedCost = 0;
    let taxPercentage = 0;
    let taxCost = 0;
    let costWithoutTax = 0;
    let finalCost = 0;
    let discount = 0;
    let costAfterDiscount = 0;

    if (rowData[3]) receivedQty = rowData[3].v ? rowData[3].v : 0;
    if (rowData[4]) foc = rowData[4].v;
    if (rowData[5]) receivedCost = rowData[5].v ? parseFloat(rowData[5].v) : 0;
    if (rowData[6]) discount = rowData[6].v ? parseFloat(rowData[6].v) : 0;
    if (rowData[7])
      costAfterDiscount = rowData[7].v ? parseFloat(rowData[7].v) : 0;
    if (rowData[8]) taxPercentage = rowData[8].v;
    if (rowData[9]) taxType = props.taxType;
    if (valType === "TAX_CHANGE") {
      taxType = value;
    } else if (rowData[9].v) {
      taxType = rowData[9].v;
    }
    if (rowData[10]) taxCost = rowData[10].v;
    if (rowData[11]) costWithoutTax = rowData[11].v;
    if (rowData[12]) finalCost = rowData[12].v;

    if (valType == "RECEIVED_QTY") {
      console.log(">>", value.v);
      receivedQty = value.v ? value.v : 0;
      if (props.costCalculationType.id === "COST_FROM_RECEIVED_COST") {
        costAfterDiscount = receivedQty * receivedCost - discount;
        costWithoutTax = costAfterDiscount;
      }
    } else if (valType == "foc") {
      foc = value.v;
    } else if (valType == "RECEIVED_COST") {
      receivedCost = value.v ? value.v : 0;
      costAfterDiscount = receivedQty * receivedCost - discount;
      costWithoutTax = costAfterDiscount;
    } else if (valType === "DISCOUNT") {
      discount = value.v ? value.v : 0;
      costAfterDiscount = receivedQty * receivedCost - discount;
      costWithoutTax = costAfterDiscount;
    } else if (valType == "TAX_CHANGE") {
      taxType = { name: value.name, id: value.id };
      if (props.costCalculationType.id === "COST_FROM_RECEIVED_COST") {
        costAfterDiscount = receivedQty * receivedCost - discount;
        costWithoutTax = costAfterDiscount;
      }
    } else if (valType == "FINAL_COST") {
      finalCost = value.v ? value.v : 0;
    }

    if (props.costCalculationType.id === "COST_FROM_FINAL_COST") {
      taxCost = 0;
      if (taxType.id == "1") {
        /*Include Tax*/
        taxPercentage = taxPercentage == null ? 0 : taxPercentage;
        taxCost = (parseFloat(finalCost) * parseFloat(taxPercentage)) / 100;
        costWithoutTax = finalCost - taxCost;
        costAfterDiscount = finalCost;
        receivedCost =
          finalCost / (receivedQty ? (receivedQty != 0 ? receivedQty : 1) : 1);
      } else if (taxType.id == "2") {
        /*Exclude Tax*/
        taxPercentage = taxPercentage == null ? 0 : taxPercentage;
        taxCost =
          (parseFloat(finalCost) * parseFloat(taxPercentage)) /
          (100 + parseFloat(taxPercentage));
        costWithoutTax = finalCost - taxCost;
        costAfterDiscount = costWithoutTax;

        receivedCost =
          costWithoutTax /
          (receivedQty ? (receivedQty != 0 ? receivedQty : 1) : 1);
      } else {
        costWithoutTax = finalCost;
        costAfterDiscount = finalCost;
        receivedCost =
          finalCost / (receivedQty ? (receivedQty != 0 ? receivedQty : 1) : 1);
      }
    } else if (valType != "foc") {
      taxCost = 0;
      if (taxType.id == "1") {
        /*Include Tax*/
        taxPercentage = taxPercentage == null ? 0 : taxPercentage;
        taxCost =
          (parseFloat(costWithoutTax) * parseFloat(taxPercentage)) /
          (100 + parseFloat(taxPercentage));
        finalCost = costWithoutTax;
        costWithoutTax = costWithoutTax - taxCost;
      } else if (taxType.id == "2") {
        /*Exclude Tax*/
        taxPercentage = taxPercentage == null ? 0 : taxPercentage;
        taxCost = (costWithoutTax * taxPercentage) / 100;
        finalCost = taxCost + costWithoutTax;
      } else {
        finalCost = costWithoutTax;
      }
    }
    setVal(rowData, 3, receivedQty, valType, "RECEIVED_QTY");
    setVal(rowData, 4, foc, valType, "foc");
    setVal(rowData, 5, receivedCost, valType, "RECEIVED_COST");
    setVal(rowData, 6, discount, valType, "DISCOUNT");
    setVal(rowData, 7, costAfterDiscount, valType, "COST_AFTER_DISCOUNT");
    setVal(rowData, 8, taxPercentage, valType, "TAX_PER");
    setVal(rowData, 9, taxType, valType, "TAX_TYPE");
    setVal(rowData, 10, taxCost, valType, "TAX_COST");
    setVal(rowData, 11, costWithoutTax, valType, "COST_WITHOUT_TAX");
    setVal(rowData, 12, finalCost, valType, "FINAL_COST");
  }

  function setVal(rowData, index, value, valType, dataType) {
    if (valType === dataType) {
      if (dataType === "foc") {
        rowData[index] = { v: { foc: value.foc, focQty: value.focQty } };
      } else {
        rowData[index] = { v: value, e: "" };
      }
    } else {
      if (dataType === "foc" && value) {
        rowData[index] = {
          v: {
            foc: value.foc,
            focQty: value.focQty,
          },
        };
      } else if (dataType === "TAX_TYPE" && value) {
        rowData[index].v = value;
      } else {
        if (isFinite(value)) {
          rowData[index] = {
            v: StringUtils.formattedNumberWithStoreDecimal(
              value,
              props.context
            ),
            e: "",
          };
        } else {
          rowData[index] = { v: "", e: "" };
        }
      }
    }
  }

  function scollToActiveElem() {
    let i = 0;
    for (var e of props.data) {
      if (e[13].info.selected) {
        const timer = setTimeout(() => {
          const node = document.getElementById("qp_table_row_" + (i - 1));
          if (node) node.scrollIntoView();
          else {
            const node = document.getElementById("qp_table_row_" + i);
            if (node) node.scrollIntoView();
          }
        }, 25);
        return () => clearTimeout(timer);
      }
      i++;
    }
  }

  function handletaxTypeChangeEvent(tableMeta, newValue) {
    let datList = [...tableMeta.tableData];
    updatevalues(datList[tableMeta.rowIndex], "TAX_CHANGE", newValue, null);
    props.updatePurchaseItemData(datList);
  }

  const columns = [
    {
      name: "serialNumber",
      label: translate("SN"),
      options: {
        filter: false,
        sort: false,
        /*customHeadLabelRender: (value, tableMeta, updateValue) => (
          <div style={{ textAlign: "left", paddingLeft: 5 }}>SN</div>
        ),*/
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 30 }}>{value.v}</div>
        ),
      },
    },
    {
      name: "productName",
      label: translate("Product Name"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div
              id={"qp_table_row_" + tableMeta.rowIndex}
              style={{ width: 300 }}
            >
              <Link
                style={{ cursor: "pointer", fontSize: "1rem" }}
                onClick={() =>
                  onLinkClikedForProductCrud(
                    tableMeta.rowData[13].info.productBean.id
                  )
                }
                underline="none"
              >
                {value.v}
              </Link>
            </div>
          );
        },
      },
    },
    {
      name: "unit",
      label: translate("Unit"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 60 }}>{value.v}</div>
        ),
      },
    },
    {
      name: "receivedQty",
      label: translate("Received Qty"),
      options: {
        filter: false,
        sort: false,
        display: "true",

        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 60 }}>
            <PText
              value={value.v}
              type="number"
              onChange={(e) =>
                updateData(
                  "table",
                  tableMeta,
                  e.target.value
                    ? { v: e.target.value, e: "" }
                    : { v: "", e: "" }
                )
              }
            ></PText>
          </div>
        ),
      },
    },
    {
      name: "foc",
      label: translate("FOC QTY"),
      options: {
        filter: false,
        sort: false,
        display: "true",

        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 130 }}>
            <table>
              <tbody>
                <tr>
                  <td>
                    <PCheck
                      checked={value.v ? value.v.foc : false}
                      onChange={(e) =>
                        updateData("table", tableMeta, {
                          v: { foc: e, focQty: 0 },
                        })
                      }
                      label={""}
                      disabled={
                        props.costCalculationType.id === "COST_FROM_FINAL_COST"
                          ? true
                          : false
                      }
                    ></PCheck>
                  </td>
                  <td>
                    <PText
                      style={{ width: 60 }}
                      value={value.v ? value.v.focQty : false}
                      type="number"
                      onChange={(e) =>
                        updateData("table", tableMeta, {
                          v: { foc: value.v.foc, focQty: e.target.value },
                        })
                      }
                      InputProps={{
                        readOnly:
                          value.v &&
                          props.costCalculationType.id ===
                            "COST_FROM_RECEIVED_COST"
                            ? !value.v.foc
                            : true,
                      }}
                    ></PText>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ),
      },
    },
    {
      name: "receivedCost",
      label: translate("Received Cost"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 70 }}>
            <PText
              value={value.v}
              type="number"
              onChange={(e) => {
                updateData(
                  "table",
                  tableMeta,
                  e.target.value
                    ? { v: e.target.value, e: "" }
                    : { v: "", e: "" }
                );
              }}
              InputProps={{
                readOnly:
                  props.costCalculationType.id === "COST_FROM_FINAL_COST"
                    ? true
                    : false,
              }}
            ></PText>
          </div>
        ),
      },
    },
    {
      name: "discount",
      label: translate("Discount"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 70 }}>
            <PText
              value={value.v}
              type="number"
              onChange={(e) => {
                updateData(
                  "table",
                  tableMeta,
                  e.target.value
                    ? { v: e.target.value, e: "" }
                    : { v: "", e: "" }
                );
              }}
              InputProps={{
                readOnly:
                  props.costCalculationType.id === "COST_FROM_FINAL_COST"
                    ? true
                    : false,
              }}
            ></PText>
          </div>
        ),
      },
    },
    {
      name: "costAfterDiscount",
      label: translate("Actual Cost"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 70 }}>
            <PText
              value={value.v}
              type="number"
              onChange={(e) => {
                updateData(
                  "table",
                  tableMeta,
                  e.target.value
                    ? { v: e.target.value, e: "" }
                    : { v: "", e: "" }
                );
              }}
              InputProps={{
                readOnly: true,
              }}
            ></PText>
          </div>
        ),
      },
    },
    {
      name: "taxPercentage",
      label: translate("Tax %"),
      options: {
        filter: false,
        sort: false,
        display: "true",

        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 50 }}>
            <PText
              value={value.v}
              type="number"
              onChange={(e) =>
                updateData(
                  "table",
                  tableMeta,
                  e.target.value
                    ? { v: e.target.value, e: "" }
                    : { v: "", e: "" }
                )
              }
              InputProps={{
                readOnly: true,
              }}
            ></PText>
          </div>
        ),
      },
    },
    {
      name: "taxType",
      label: translate("Tax Type"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        noWrap: true,
        /* eslint-disable react/display-name */
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 150 }}>
            <PSelect
              options={props.taxTypeOptions}
              value={value.v}
              onChange={(event, newValue) => {
                handletaxTypeChangeEvent(tableMeta, newValue);
              }}
            ></PSelect>
          </div>
        ),
      },
    },
    {
      name: "taxCost",
      label: translate("Tax Cost"),
      options: {
        filter: false,
        sort: false,
        display: "true",

        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 70 }}>
            <PText
              value={value.v}
              type="number"
              onChange={(e) =>
                updateData(
                  "table",
                  tableMeta,
                  e.target.value
                    ? { v: e.target.value, e: "" }
                    : { v: "", e: "" }
                )
              }
              InputProps={{
                readOnly: true,
              }}
            ></PText>
          </div>
        ),
      },
    },
    {
      name: "costWIthoutTax",
      label: translate("Cost W/O Tax"),
      options: {
        filter: false,
        sort: false,
        display: "true",

        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 70 }}>
            <PText
              value={value.v}
              type="number"
              onChange={(e) =>
                updateData(
                  "table",
                  tableMeta,
                  e.target.value
                    ? { v: e.target.value, e: "" }
                    : { v: "", e: "" }
                )
              }
              InputProps={{
                readOnly: true,
              }}
            ></PText>
          </div>
        ),
      },
    },
    {
      name: "finalCost",
      label: translate("Final Cost"),
      options: {
        filter: false,
        sort: false,
        display: "true",

        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 100 }}>
            <PText
              value={value.v}
              type="number"
              onChange={(e) =>
                updateData(
                  "table",
                  tableMeta,
                  e.target.value
                    ? { v: e.target.value, e: "" }
                    : { v: "", e: "" }
                )
              }
              InputProps={{
                readOnly:
                  props.costCalculationType.id === "COST_FROM_FINAL_COST"
                    ? false
                    : true,
              }}
            ></PText>
          </div>
        ),
      },
    },
    {
      name: "action",
      label: translate("Action"),
      options: {
        filter: false,
        sort: false,
        display: props.viewMode == "view" ? "false" : "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ textAlign: "right" }}>
            <Tooltip title={translate("Remove Pricing")}>
              <IconButton
                color="secondary"
                onClick={() =>
                  onRemoveItemClicked(tableMeta, updateValue, value)
                }
              >
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </div>
        ),
      },
    },
  ];

  function onRemoveItemClicked(tableMeta, updateValue, value) {
    let data = [...tableMeta.tableData];

    data.splice(tableMeta.rowIndex, 1);
    let index = 0;
    data.map((item) => {
      data[index][0].v = index + 1;
      index++;
    });
    resetSelection(data, tableMeta.rowIndex);
    props.updatePurchaseItemData(data);
  }

  const formatOptionLabel = (option, { context }) => {
    if (context === "menu") {
      return (
        <Grid container>
          <Grid item xs={2}>
            {option.value.unitType}
          </Grid>
          <Grid item xs={2}>
            {option.value.code}
          </Grid>
          <Grid item xs={4}>
            {option.value.name}
          </Grid>
          <Grid item xs={2} style={{ paddingLeft: "25px" }}>
            {option.value.cost}
          </Grid>
          <Grid item xs={2}>
            {option.value.price}
          </Grid>
        </Grid>
      );
    }
    if (!option.label) return "";
    return option.label.name;
  };

  const options = {
    textLabels: {
      body: {
        noMatch: translate("Search or Scan the product"),
      },
    },
    filterType: "checkbox",
    filter: false,
    search: false,
    print: false,
    download: false,
    viewColumns: false,
    customToolbar: false,
    title: false,
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    tableBodyMaxHeight: "100%",
    tableBodyHeight: dataTableHeight,
    pagination: false,
    responsive: "standard",
    setRowProps: (row, dataIndex, rowIndex) => {
      if (props.data.length > 0 && props.data[rowIndex][13].info.selected) {
        return {
          style: { background: "#fffbc4" },
        };
      }
    },
    /*onRowClick: (rowData, rowMeta, rowIndex) => {
    },*/
    onCellClick: (colData, cellMeta) => {
      if (cellMeta.colIndex != 13) {
        var data = [...props.data];
        resetSelection(props.data, cellMeta.rowIndex);
        props.updatePurchaseItemData(data);
      }
    },
  };

  function resetSelection(data, rowIndex) {
    for (let i = 0; i < data.length; i++) {
      if (rowIndex == i) data[i][13].info.selected = true;
      else data[i][13].info.selected = false;
    }
  }

  const getOptions = (inputValue, callback) => {
    getOptionsAsync(inputValue, callback);
  };

  function onProductSaved(prodBean) {
    console.log(prodBean);
  }

  async function getOptionsAsync(inputValue, callback) {
    let arr = await SyncUtils.searchInCache(
      props.productCache,
      inputValue,
      100
    );
    return callback(
      arr.map(function (option, index) {
        return {
          value: option,
          label: option,
        };
      })
    );

    //return callback([]);
  }

  function getItemIndex(productId, itemList) {
    let index = null;
    for (let i = 0; i < itemList.length; i++) {
      if (itemList[i][13].info.productBean.id == productId) {
        index = i;
        break;
      }
    }
    return index;
  }

  function updatePurchaseItemQty(itemList, index, newValue) {
    /*let receivedQty = 0;
    let foc = {};
    let receivedCost = 0;
    let taxPercentage = 0;
    let taxCost = 0;
    let costWithoutTax = 0;
    let finalCost = 0;
    let taxType = {};
    let discount = 0;
    let costAfterDiscount = 0;

    if (itemList[index][3]) receivedQty = parseFloat(itemList[index][3].v);
    if (itemList[index][4]) foc = parseFloat(itemList[index][4].v);
    if (itemList[index][5]) receivedCost = itemList[index][5].v?parseFloat(itemList[index][5].v):0;
    if (itemList[index][6]) discount = itemList[index][6].v ? parseFloat(itemList[index][6].v) : 0;
    if (itemList[index][7]) costAfterDiscount = itemList[index][7].v
      ? parseFloat(itemList[index][7].v)
      : 0;
    if (itemList[index][8]) taxPercentage = parseFloat(itemList[index][6].v);
    if (itemList[index][9])
      taxType = itemList[index][9].v ? itemList[index][9].v : props.taxType;
    if (itemList[index][10]) taxCost = parseFloat(itemList[index][10].v);
    if (itemList[index][11]) costWithoutTax = parseFloat(itemList[index][11].v);
    if (itemList[index][12]) finalCost = parseFloat(itemList[index][12].v);

    receivedQty = receivedQty + newValue;
    costAfterDiscount = receivedQty * receivedCost-discount;
    costWithoutTax =
      costAfterDiscount;


    if (taxType.id == "1") {
      //Include Tax
      taxCost =
        (parseFloat(costWithoutTax) * parseFloat(taxPercentage)) /
        (100 + parseFloat(taxPercentage));
      finalCost = costWithoutTax;
      costWithoutTax = costWithoutTax - taxCost;
    } else if (taxType.id == "2") {
      //Exclude Tax
      taxCost = (costWithoutTax * taxPercentage) / 100;
      finalCost = taxCost + costWithoutTax;
    } else {
      finalCost = costWithoutTax;
      taxCost = 0;
    }

    let orderItem = [
      { v: itemList[index][0].v },
      { v: itemList[index][1].v },
      { v: itemList[index][2].v },
      { v: receivedQty },
      { v: foc },
      { v: receivedCost },
      { v: discount },
      { v: costAfterDiscount },
      {
        v: itemList[index][6].v,
      },
      { v: taxType },
      { v: StringUtils.formattedNumber(taxCost) },
      { v: StringUtils.formattedNumber(costWithoutTax) },
      { v: StringUtils.formattedNumber(finalCost) },
      {
        info: itemList[index][13].info,
      },
    ];

    itemList[index] = orderItem;*/
    resetSelection(itemList, index);
    props.updatePurchaseItemData(itemList);
  }

  function onAddProduct(productBean, pricingBean, rowId) {}

  async function addProductToTable(productBean, pricingBean, rowIx) {
    var data = [...props.data];
    let itemIndex = getItemIndex(productBean.id, data);
    sessionStorage.setItem("enableAutoScroll", "true");
    if (itemIndex != null && isConsolidated) {
      updatePurchaseItemQty(data, itemIndex, 0);
    } else {
      let sn = data.length + 1;

      let derivedCost = pricingBean.cost;
      if (props.taxType.id == "1") {
        derivedCost = StringUtils.formattedNumber(
          parseFloat(derivedCost) +
            parseFloat(derivedCost) *
              (parseFloat(productBean.taxBean.rate) / 100),
          props.context.store.currencyDecimal
        );
      }

      let orderItem = [
        { v: sn },
        { v: productBean.name },
        { v: pricingBean.unitType },
        { v: 0 },
        { v: { foc: false, focQty: 0 } },
        { v: derivedCost },
        { v: 0 },
        { v: 0 },
        {
          v:
            productBean.taxBean != null &&
            (productBean.taxBean != null) != undefined
              ? productBean.taxBean.rate
              : "0",
        },
        {
          v: props.taxType
            ? { name: props.taxType.name, id: props.taxType.id }
            : { name: "Include Tax", id: "1" },
        },
        { v: "0" },
        { v: "0" },
        { v: "0" },
        {
          info: {
            productBean: productBean,
            pricingBean: pricingBean,
            selected: false,
            calculationType: props.costCalculationType,
          },
        },
      ];
      console.log("rowIx", rowIx);
      if (rowIx != null) {
        data[rowIx] = orderItem;
        resetSelection(data, rowIx);
      } else {
        data.push(orderItem);
        resetSelection(data, data.length - 1);
      }
      props.updatePurchaseItemData(data);
    }
  }

  const productLookupChanged = (newValue) => {
    prodSelected(newValue);
  };

  async function prodSelected(newValue) {
    let [prodBean, pricingBean] = await SyncUtils.getProductBean(
      newValue.value
    );
    if (prodBean == null || pricingBean == null) {
      alert("Product got Deleted or Modifed, please Reload the Window");
    } else {
      await addProductToTable(prodBean, pricingBean);
    }
    setProdLookupValue({ label: null, value: null });
  }

  function productListRefresh() {}

  function handleWIthTaxChangeEvent(value) {
    props.setTaxType(value);
    let datList = [...props.data];
    for (let i = 0; i < datList.length; i++) {
      updatevalues(datList[i], "TAX_CHANGE", value, null);
    }
    props.updatePurchaseItemData(datList);
  }

  function handleCostCalculationTypeChangeEvent(value) {
    props.setCostCalculationType(value);
    let datList = [...props.data];
    for (let i = 0; i < datList.length; i++) {
      datList[i][4].v = { foc: false, focQty: 0 };
      datList[i][5].v = 0;
      datList[i][6].v = 0;
      datList[i][7].v = 0;
      datList[i][11].v = 0;
    }
    props.updatePurchaseItemData(datList);
  }

  function rejectdBarcode(barcode) {
    console.log("Rejected Barcode :", barcode);
  }

  function onBarcodeScanned(barcode) {
    console.log("Scuccess Barcode :", barcode);
    findProductByBarcode(barcode);
  }

  function getPricingFromBarcode(productBean, barcode) {
    for (let pricing of productBean.productPricingBeanList) {
      for (let barcodeBean of pricing.productBarcodeBeanList) {
        if (barcodeBean.barcode == barcode) {
          return pricing;
        }
      }
    }
  }

  async function findProductByBarcode(barcode) {
    let dbData = await db.product
      .where("barcodeList")
      .equals(barcode)
      .toArray();
    if (dbData.length == 0) {
      props.showMessage("warning", "Product Not Found");
    } else {
      let productBean = dbData[0];
      let pricingBean = getPricingFromBarcode(productBean, barcode);
      await addProductToTable(productBean, pricingBean);
    }
  }

  function onClearCacheClicked() {
    setConfirmContext({
      title: "Are You Sure",
      message:
        "Are you sure to clear the cached data,This action can't revert!",
      type: "warning",
      open: true,
      yes: true,
      no: true,
    });
    setConfirmOpen(true);
  }

  async function onYesNoClicked(context, value) {
    setConfirmOpen(false);
    if (value == "yes") {
      if (props.isReturn) {
        localStorage.removeItem("purchaseReturnOrderLineItems");
        localStorage.removeItem("purchaseReturnCostCalculationType");
        localStorage.removeItem("purchaseReturnTaxType");
      } else {
        localStorage.removeItem("purchaseOrderLineItems");
        localStorage.removeItem("purchaseOrderCostCalculationType");
        localStorage.removeItem("purchaseOrderTaxType");
      }
      props.setTaxType(props.taxTypeOptions[0]);
      props.setCostCalculationType(props.costCalculationTypeOptions[0]);
      props.updatePurchaseItemData([]);
    }
  }

  const handleCapture = ({ target }) => {
    if (target.files.length > 0) {
      setShowImport(true);
    } else {
      setShowImport(false);
    }
  };

  async function onImport() {
    setLoading(true);
    setDisableLoading(true);
    setDisableImport(true);
    const input = document.getElementById("po_import_input");
    try {
      let rows = await readXlsxFile(input.files[0]);
      let colMap = validateColumns(rows);
      if (colMap) {
        if (props.isReturn)
          localStorage.removeItem("purchaseReturnOrderLineItems");
        else localStorage.removeItem("purchaseOrderLineItems");
        props.updatePurchaseItemData([]);
        importTo(rows, colMap);
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
      setAlertFlag(true);
      setAlertMessage("Error While Importing Data");
    }
    setLoading(false);
    setDisableLoading(false);
    setDisableImport(false);
  }

  async function importTo(rows, colMap) {
    let data = [];
    let count = 0;

    for (let r of rows) {
      count++;
      if (count == 1) continue;
      console.log(r[colMap["Barcode"]]);
      let barcode = strip(r[colMap["Barcode"]]);
      let receivedQty = strip(r[colMap["Quantity"]]);
      let receivedCost = strip(r[colMap["Cost"]]);

      console.log("Barcode>" + barcode + "<<<");
      let dbData = await db.product
        .where("barcodeList")
        .equals(barcode)
        .toArray();
      if (dbData.length == 0) {
        props.showMessage("warning", "Product Not Found");
      } else {
        let productBean = dbData[0];
        let pricingBean = getPricingFromBarcode(productBean, barcode);

        let costWithoutTax = receivedQty * receivedCost;
        let taxPercentage =
          productBean.taxBean == null ? 0 : productBean.taxBean.rate;
        let taxCost = 0;
        let finalCost = 0;
        if (props.taxType.id == "1") {
          /*Include Tax*/
          taxCost =
            (parseFloat(costWithoutTax) * parseFloat(taxPercentage)) /
            (100 + parseFloat(taxPercentage));
          finalCost = costWithoutTax;
          costWithoutTax = costWithoutTax - taxCost;
        } else if (props.taxType.id == "2") {
          /*Exclude Tax*/
          taxCost = (costWithoutTax * taxPercentage) / 100;
          finalCost = taxCost + costWithoutTax;
        } else {
          finalCost = costWithoutTax;
          taxCost = 0;
        }

        let orderItem = [
          { v: count },
          { v: productBean.name },
          { v: pricingBean.unitType },
          { v: receivedQty },
          { v: { foc: false, focQty: 0 } },
          { v: receivedCost },
          { v: productBean.taxBean.rate },
          {
            v: StringUtils.formattedNumber(
              taxCost,
              props.context.store.currencyDecimal
            ),
          },
          {
            v: StringUtils.formattedNumber(
              costWithoutTax,
              props.context.store.currencyDecimal
            ),
          },
          {
            v: StringUtils.formattedNumber(
              finalCost,
              props.context.store.currencyDecimal
            ),
          },
          {
            info: {
              productBean: productBean,
              pricingBean: pricingBean,
              selected: false,
              calculationType: props.costCalculationType,
            },
          },
        ];

        data.push(orderItem);
      }
    }
    props.updatePurchaseItemData(data);
  }

  function strip(string) {
    console.log(string);
    return string + "".replace(/^\s+|\s+$/g, "");
  }

  const colMapping = {
    Barcode: {
      manadatory: true,
      options: ["barcode", "Barcode", "barcodes", "الرمز الشريطي"],
    },
    Quantity: {
      manadatory: true,
      options: ["Quantity", "Received Qty", "Received Quantity", "Qty", "كمية"],
    },
    Cost: {
      manadatory: true,
      options: ["Cost", "Received Cost", "كلفة", "التكلفة المستلمة"],
    },
  };

  function validateColumns(rows) {
    let col = [];
    let colMap = {};
    let failureMap = [];
    let failed = false;
    for (var key in colMapping) {
      let col = colMapping[key];
      let colFound = false;
      let colIndex = -1;
      let ix = 0;
      for (let r of rows[0]) {
        if (r) {
          for (let opt of col.options) {
            if (r.toUpperCase() === opt.toUpperCase()) {
              colFound = true;
              colIndex = ix;
            }
          }
          ix++;
        }
      }
      if (colFound) {
        colMap[key] = colIndex;
      } else {
        if (col.manadatory) {
          failed = true;
          console.log("MANDATORY NOT FOUND", key);
          failureMap.push({
            key: key,
            message: "Manadatory Column " + key + " Not Found",
          });
        }
      }
    }
    if (failed) {
      let col = "";
      let comma = "";
      for (let err of failureMap) {
        col = comma + err.key;
        comma = ",";
      }
      setAlertMessage(
        "Not Able to Find mandatory columns (" + col + ") in Uploaded Excel "
      );
      setAlertFlag(true);
      return false;
    }
    return colMap;
  }
  function openAlert(flag) {
    setAlertFlag(flag);
  }

  return (
    <div>
      <BarcodeReader
        onError={rejectdBarcode}
        onScan={onBarcodeScanned}
        preventDefault={true}
        avgTimeByChar={
          props.context.storeAdmin.barcodeScanAvgTimeByChar
            ? props.context.storeAdmin.barcodeScanAvgTimeByChar
            : 30
        }
      ></BarcodeReader>
      <Grid container>
        <Grid item xs={12} sm={12}>
          <table width="100%">
            <tr>
              {/*<td width="39%">
               <AsyncSelect
                  formatOptionLabel={formatOptionLabel}
                  components={{ formatOptionLabel }}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 99999,
                    }),
                    marginRight: "10px",
                  }}
                  placeholder={translate("Product Lookup")}
                  loadOptions={getOptions}
                  onChange={productLookupChanged}
                  onKeyDown={(e) => {
                    e.stopPropagation();
                    e.nativeEvent.stopImmediatePropagation();
                  }}
                  value={prodLookupValue}
                  //options={cities}
                />
              </td>{" "}
              */}
              <td width="3%">
                <Tooltip title={"Create product"}>
                  <IconButton
                    aria-label="close"
                    onClick={() => {
                      setOrigObject(null);
                      setShowProductCrud(true);
                    }}
                  >
                    <AddIcon />
                  </IconButton>
                </Tooltip>
              </td>
              <td width="10%">
                <PCheck
                  onChange={(value) => setConsolidated(value)}
                  checked={isConsolidated}
                  label={translate("Consolidated")}
                ></PCheck>
              </td>
              <td width="15%">
                <PSelect
                  options={props.taxTypeOptions}
                  value={props.taxType}
                  onChange={(event, newValue) => {
                    handleWIthTaxChangeEvent(newValue);
                  }}
                ></PSelect>
              </td>
              <td width="25%">
                <PSelect
                  options={props.costCalculationTypeOptions}
                  value={props.costCalculationType}
                  onChange={(event, newValue) => {
                    handleCostCalculationTypeChangeEvent(newValue);
                  }}
                ></PSelect>
              </td>
              {props.viewMode != "view" && (
                <td width="3%" style={{ paddingLeft: "10px" }}>
                  <Tooltip title={translate("Clear Cache")}>
                    <IconButton
                      color="secondary"
                      onClick={() => {
                        onClearCacheClicked();
                      }}
                    >
                      <DeleteSweepOutlinedIcon />
                    </IconButton>
                  </Tooltip>
                </td>
              )}
            </tr>
            {productSetting &&
              productSetting.enableDataUploadFeatureInPurchaseOrder && (
                <tr>
                  <td>
                    <Grid container>
                      <Grid item xs={12}>
                        <Grid container>
                          <Grid item>
                            <Button variant="contained" component="label">
                              Import
                              <input
                                id="po_import_input"
                                type="file"
                                onChange={handleCapture}
                              />
                            </Button>
                          </Grid>
                          <Grid item>
                            {showImport && (
                              <Button
                                variant="contained"
                                component="label"
                                color="primary"
                                onClick={onImport}
                                disabled={disableLoading}
                              >
                                {loading && <CircularProgress size={20} />} LOAD
                              </Button>
                            )}
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item x={12}>
                        <Collapse in={alertFlag}>
                          <Alert
                            severity="error"
                            action={
                              <IconButton
                                aria-label="close"
                                color="error"
                                size="small"
                                onClick={() => {
                                  openAlert(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {alertMessage}
                          </Alert>
                        </Collapse>
                      </Grid>
                    </Grid>
                  </td>
                </tr>
              )}
          </table>
        </Grid>
        <Grid item xs={12} sm={12}>
          {/*<MUIDataTable
            data={props.data}
            columns={columns}
            options={options}
                          ></MUIDataTable>*/}
          <AgGridQuickPurchaseList
            biRef={biRef}
            context={props.context}
            data={props.data}
            updatevalues={updatevalues}
            updatePurchaseItemData={props.updatePurchaseItemData}
            onAddProduct={addProductToTable}
            isConsolidated={isConsolidated}
            getItemIndex={getItemIndex}
            onLinkClikedForProductCrud={onLinkClikedForProductCrud}
            resetSelection={resetSelection}
          ></AgGridQuickPurchaseList>
        </Grid>
        {showProductCrud && (
          <ProductCrud
            onRefresh={productListRefresh}
            readOnly={props.readOnly}
            showMessage={props.showMessage}
            showProgress={props.showProgress}
            hideProgress={props.hideProgress}
            setProgressMessage={props.setProgressMessage}
            setAlert={props.setAlert}
            context={props.context}
            productType="I"
            unitTypeOptions={unitTypeOptions}
            productInfoFields={productInfoFields}
            storeAdminSetting={storeAdminSetting}
            setShowCrud={setShowProductCrud}
            onProductSaved={onProductSaved}
            origObject={origObject}
            setOrigObject={setOrigObject}
            pricingLevels={pricingLevels}
            //TODO mount promotion options
          ></ProductCrud>
        )}

        {confirmOpen && (
          <PConfirm
            open={confirmOpen}
            context={confirmContext}
            onButtonClicked={onYesNoClicked}
          ></PConfirm>
        )}
      </Grid>
    </div>
  );
}
